module.exports = __webpack_public_path__ + "static/media/missions.d40c5894.svg";